import { AlertService } from 'app/services/alert.service';
import { DatePipe, DecimalPipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Router } from '@angular/router';
import { Garantia } from 'app/models/Garantia';
import { MessagesTitles, MessagesGeneral, MessagesDates, MessagesStatus } from 'app/models/messages';
import { LoginService } from 'app/services/login/login.service';
import { RiesgoService } from 'app/services/riesgo/riesgo.service';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-listado-garantias',
  templateUrl: './listado-garantias.component.html',
  styleUrls: ['./listado-garantias.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesDates, MessagesStatus, DatePipe, DecimalPipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class ListadoGarantiasComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  displayedColumns = ['checked', 'idGarantia', 'Nombre_Garantia', 'Moneda', 'Monto_Cobertura_Maxima',
    'Monto_Cobertura_Disponible', 'Monto_Cobertura_Ejecutado', 'Estado'];
  pageSizeOptions = [10, 20, 30, 50, 100, 200];
  dataSource: any;
  IP: string = '';
  fechaActual: string;
  readonly CANAL_AUDITORIA: string = 'W';
  userActive: any;
  garantias: Garantia[] = [];
  estadosGarantia: any[] = [];
  monedasGarantia: any[] = [];
  garantia: Garantia;
  formGarantia: FormGroup;
  value: any;
  loading: boolean = false;
  nombreFilter: FormControl = new FormControl('');
  estadoFilter: FormControl = new FormControl('');
  monedaFilter: FormControl = new FormControl('');
  filterValues: any = {
    nombre: '',
    estado: '',
    moneda: ''
  }
  subLista: Subscription[] = [];
  subListaGarantias: Subscription = new Subscription();

  constructor(
    private riesgoService: RiesgoService,
    private formBuilder: FormBuilder,
    private router: Router,
    private loginService: LoginService,
    private alertService: AlertService
  ) {
    this.IP = JSON.parse(sessionStorage.getItem('PUBLIC-IP')).ip ? JSON.parse(sessionStorage.getItem('PUBLIC-IP')).ip : '192.168.1.1';
    this.userActive = JSON.parse(sessionStorage.getItem('UserActive'));
    this.fechaActual = new Date().toISOString().split('T')[0];

    this.estadosGarantia = this.riesgoService.Estados;
    this.monedasGarantia = this.riesgoService.Monedas;

    this.nombreFilter.valueChanges.subscribe(
      status => {
        this.filterValues.nombre = status;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );

    this.estadoFilter.valueChanges.subscribe(
      status => {
        this.filterValues.estado = status;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );

    this.monedaFilter.valueChanges.subscribe(
      source => {
        this.filterValues.moneda = source;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
  }

  ngOnInit() {
    this.monedasGarantia.forEach(moneda => moneda.value = (moneda.key === '') ? 'Todos' : moneda.value);

    this.listadoGarantias();
  }

  /**
  * Función para obtener todas las garantias desde la BD.
  */
  listadoGarantias() {
    this.loading = true;
    this.subListaGarantias = this.riesgoService.obtenerGarantias().subscribe(
      (resGarantias: Garantia[]) => {
        this.garantias = resGarantias;
        this.loading = false;
        this.garantias.forEach((g: Garantia) => {
          for (const iterator of this.monedasGarantia) {
            if (iterator.key == g.Moneda.toString()) {
              g.Moneda_Symbol = iterator.symbol;
            }
          }
        });
        this.dataSource = new MatTableDataSource(this.garantias);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.dataSource.filterPredicate = this.crearFiltro();
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        Swal.fire({
          title: 'Error',
          html: this.alertService.createTextError(err, 'Garantías no obtenidas. <br/>'),
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    );

    this.subLista.push(this.subListaGarantias);
  }

  /**
  * Función para crear un filtro sobre el listado de garantias existentes (evitando la llamada al service).
  */
  private crearFiltro(): (garantia: Garantia, filter: string) => boolean {
    return function (garantia: Garantia, filter: string): boolean {
      let searchTerms = JSON.parse(filter);
      return garantia.Nombre_Garantia.toLowerCase().indexOf(searchTerms.nombre.toLowerCase()) != -1
        && garantia.Moneda.toString().indexOf(searchTerms.moneda) != -1
        && garantia.Estado.indexOf(searchTerms.estado) != -1;
    }
  }

  /**
  * Función para abrir el formulario de registro de garantias.
  */
  crearNuevaGarantia() {
    this.riesgoService.flagCrear = true;
    this.riesgoService.flagEditar = false;
    this.riesgoService.flagVer = false;
    this.loginService.clickGuard = true;
    this.router.navigate(['/fondo/concentracion/garantias/nuevo']);
  }

  /**
  * Función para abrir el formulario de actualización de garantias.
  */
  editarGarantia(garantia: any) {
    this.riesgoService.dataGarantia = garantia;
    this.riesgoService.flagCrear = false;
    this.riesgoService.flagEditar = true;
    this.riesgoService.flagVer = false;
    this.loginService.clickGuard = true;
    this.router.navigate(['/fondo/concentracion/garantias/nuevo']);
  }

  /**
  * Función para abrir el formulario de detalle de garantias.
  */
  verDetalleGarantia(garantia: any) {
    this.riesgoService.dataGarantia = garantia;
    this.riesgoService.flagCrear = false;
    this.riesgoService.flagEditar = false;
    this.riesgoService.flagVer = true;
    this.loginService.clickGuard = true;
    this.router.navigate(['/fondo/concentracion/garantias/nuevo']);
  }

  /**
  * Función para preparar la data a enviar para el cambio de estado de la garantía (activar, desactivar).
  */
  armarBodyGarantia(garantia: Garantia, estado: string) {
    this.formGarantia = this.formBuilder.group({
      IdGarantia: garantia.idGarantia,
      Estado: estado,
      Usuario: this.userActive.Usuario,
      ModificacionFecha: this.fechaActual,
      ModificacionCanal: this.CANAL_AUDITORIA,
      IP: this.IP
    });
  }

  /**
  * Función que llama al service de cambio de estado de la garantía. 
  */
  cambiarEstadoGarantia(garantia: Garantia, estado: string) {
    let textSwal = (estado == 'A') ? 'Activar la garantía?' : 'Dar de baja la garantía?';
    let textConfirmBtnSwal = (estado == 'A') ? 'Si, activar' : 'Si, dar de baja';
    Swal.fire({
      text: textSwal,
      type: 'question',
      showCancelButton: true,
      cancelButtonText: 'No, cancelar',
      showConfirmButton: true,
      confirmButtonText: textConfirmBtnSwal,
      allowOutsideClick: false,
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {

        this.armarBodyGarantia(garantia, estado);

        Swal.fire({
          title: 'Espere',
          text: 'Guardando los cambios...',
          type: 'info',
          allowOutsideClick: false,
          heightAuto: false
        });
        Swal.showLoading();

        this.riesgoService.cambiarEstadoGarantia(this.formGarantia.getRawValue(), garantia.idGarantia).subscribe(
          () => {
            let textConfirmService = (estado == 'A') ? '¡La garantía N° '.concat(garantia.idGarantia.toString(), ' ha sido activada!') : '¡La garantía N° '.concat(garantia.idGarantia.toString(), ' se ha deshabilitado!');
            Swal.fire({
              title: 'Éxito',
              text: textConfirmService,
              type: 'success',
              allowOutsideClick: false,
              heightAuto: false
            });

            this.listadoGarantias();
          },
          (err: HttpErrorResponse) => {
            this.loading = false;
            Swal.fire({
              title: 'Error',
              html: (estado == 'A') ? this.alertService.createTextError(err, 'Hubo un error a la hora de activar la garantía. <br/>') : this.alertService.createTextError(err, 'Hubo un error a la hora de deshabilitar la garantía. <br/>'),
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            });
          }

        );

      }
    });
  }
}
